export default __webpack_public_path__ + "static/media/Gilroy-HeavyItalic.83e72a40.woff";